import React from 'react';
import arrowDown from '../assets/arrow_down.svg';
import devices from '../assets/devices.png';
import './home.css';
import FadeInSection from '../animation/fadein_onscroll';
import LandingSection from '../components/columns/columns';
import Features from '../components/features/features';
import Testimonials from '../components/testimonials/testimonials';
import Menu from '../components/menu/menu';
import Plans from '../components/plans/plans';
import { useTranslation } from 'react-i18next';

document.querySelectorAll('a[data-scroll]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();

    document.querySelector(this.getAttribute('href')).scrollIntoView({
      behavior: 'smooth'
    });
  });
});

function App() {
  const { t } = useTranslation();

  return (
    <div className="App" id='start'>
      <Menu tabindex="0"/>
      <header className="app-header">
        
        <div className="left-half">
          <FadeInSection>
            <div className="app-header-content">
              <h1 className="max-width-text">
                {t('hero.title')}
              </h1>
              <p className="max-width-text">
                {t('hero.description')}
              </p>

              <div className="app-header-buttons">
                <a href='#plans' className="button-primary large margin-right" tabindex="2">{t('hero.ctaPrimary')}</a>
                <a href='#about' className="button-secondary large margin-right" tabindex="2">{t('hero.ctaSecondary')}</a>
              </div>
            </div>

        </FadeInSection>
        </div>
        <a href="#about" className="see-more" tabindex="2">
          <img src={arrowDown} alt="symbol" />
        </a>
        <div className="right-half">
        <FadeInSection>
          <img src={devices} alt="symbol" />
        </FadeInSection>
        </div>
      </header>

      <FadeInSection>
        <section id="about" className="Section small center" tabindex="2">
          <LandingSection />
        </section>
      </FadeInSection>

      <FadeInSection>
        <section id="features" className="">
          <Features />
        </section>
      </FadeInSection>

      <FadeInSection>
        <section className="">
          <Testimonials />
        </section>
      </FadeInSection>

      <FadeInSection>
        <section id="plans" className="">
          <Plans />
        </section>
      </FadeInSection>
      
    </div>
  );
}

// ReactDOM.render(<App />, document.getElementById('root'));

export default App;
